<template>

  <v-overlay
    v-model="overlay"
    scroll-strategy="block"
    persistent
  >
  </v-overlay>
  
    <div class="main"
      @drop.prevent
      @dragover.prevent
      @dragleave.prevent
       style="min-width:95vw; max-width:95vw"
    >
  
      <v-stepper v-model="currentStep" class="w-50">
        <template v-slot:default="{ prev, next }">
          <v-stepper-header>
  
            <v-stepper-item
              :complete="currentStep > 1"
              step="1"
              value="1"
              :color="stepStatus(1)"
              title="Upload Document"
            ></v-stepper-item>
  
            <v-divider></v-divider>
            
            <v-stepper-item
              :complete="importSuccess === true"
              step="2"
              value="2"
              :color="importSuccess ? 'green' : stepStatus(2)"
              title="Import Document"
            ></v-stepper-item>
  
          </v-stepper-header>
  
          <v-stepper-window>
            <v-stepper-window-item 
              step="1"
              value="1"
              >
              <v-card flat class="card ga-8">
                <div>
                  <v-select
                    v-model="className"
                    density="compact"
                    variant="outlined"
                    label="Select Document"
                    :items="classNames"
                    style="min-width: 250px; max-height: 25px;"
                  ></v-select>
                </div>

                <div class="helpToolbar">
                  <v-btn :disabled="className.length===0" @click="viewMapping" prepend-icon="mdi-sitemap-outline" rounded="sm" size="small" block>
                    View Mapping
                  </v-btn>
                  <br />
                  <v-btn @click="viewGuide" prepend-icon="mdi-help-circle" rounded="sm" size="small" block>
                    View Guide
                  </v-btn>
                </div>
  
                <div>
                  <v-select
                    v-model="quarter"
                    density="compact"
                    variant="outlined"
                    label="Select Quarter"
                    :items="quarters"
                    style="min-width: 250px; max-height: 25px;"
                  ></v-select>
                </div>
  
                <div>
                  <v-select
                    v-model="week"
                    density="compact"
                    variant="outlined"
                    label="Select Week"
                    :items="weeks"
                    style="min-width: 250px; max-height: 25px;"
                  ></v-select>
                </div>
  
                <div v-show="className.length > 0 && quarter.length > 0 && week.length > 0" style="position: relative;">
                  <v-btn 
                    @click="resetUploader" 
                    icon="mdi-close" 
                    style="position: absolute; top: 9px; right: 10px; z-index: 10;" size="x-small"
                    v-show="selectedFile !== null"
                    color="warning"
                    variant="outlined" > </v-btn>
                  <singleFileUpload ref="uploaderRef"
                    :content-types="excelStore.excelContentTypes" 
                    @fileToProcess="(file) => fileToProcess(file)">                      
                  </singleFileUpload>                    
                </div>
               
              </v-card>  
            </v-stepper-window-item>
  
            <v-stepper-window-item 
              step="2"
              value="2">
              <v-card flat class="card ga-10">
                <div>
                  <v-btn @click="importDocument" prepend-icon="mdi-list-status" rounded="xl" size="x-large" block>
                    Verify and Import
                  </v-btn>
                </div>
  
                <div style="text-align: start;">
                  <v-list density="compact">
                    <v-list-subheader>RESULT</v-list-subheader>
  
                    <v-list-item
                      v-for="(item, i) in importResult"
                      :key="i"
                      :value="item"
                      color="primary"                    
                    >
                      <template v-slot:prepend>
                        <v-icon v-show="importSuccess === true" icon="mdi-check-bold" color="success" size="small"></v-icon>
                        <v-icon v-show="importSuccess === false" icon="mdi-close-thick" color="error" size="small"></v-icon>
                      </template>
                      <v-list-item-subtitle>
                        {{ item }}  
                        <v-tooltip
                        activator="parent"
                        location="top"
                      >
                      {{ item }}                      
                      </v-tooltip>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-stepper-window-item>
  
          </v-stepper-window>
  
          <v-stepper-actions
            :disabled="disableButton"
            @click:next="next"
            @click:prev="prev"
          ></v-stepper-actions>
  
        </template>
      </v-stepper>
  
    </div>

    <v-dialog v-model="showHelp" width="950" scrollable>
      <v-card>
          <v-toolbar>
              <v-toolbar-title>{{helpTitle}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
              <v-data-table v-show="showMappingHelp" items-per-page="50" :headers="mappingHeaders" :items="mappingData"
                class="v-data-table">
              </v-data-table>
              <v-list v-show="showGuideHelp"
                :items="guidelines"
              ></v-list>
          </v-card-text>
          <v-card-actions class="border-t-thin">
              <v-btn @click="showHelp = false" width="100">Close</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>

  </template>
  
  <script setup>
  
  import { ref, computed, onMounted } from 'vue'
  import { useExcelStore } from '@/stores/excel'
  import { useSystemStore } from '@/stores/system'

  import singleFileUpload from '@/components/SingleFileUpload.vue'

  const excelStore = useExcelStore()
  const systemStore = useSystemStore()
  
  const className = ref('')
  const classNames = ref([
    'Participation Document',
    'OBSFDC Document',
    'CSG Document',    
    'CSG Partial Document',
    'ISG Document',    
    'ISG Partial Document',
    'EVoucher Status Document',
    'Distributors Document',    
    'Credit Note Document',
    'EVoucher Reference Document'
    //'Bonus Document'
  ])
  
  const quarter = ref('')
  const quarters = ref([])
  
  const week = ref('')
  const weeks = ref([])
  
  const selectedFile = ref(null)
  
  const currentStep = ref(0)
  const totalSteps = ref(2)
  
  const overlay = ref(false)
  
  const importResult = ref([])
  const importSuccess = ref(false)
  
  const showHelp = ref(false)
  const helpTitle = ref('')
  const showMappingHelp = ref(false)
  const showGuideHelp = ref(false)
  const mappingData = ref([])
  const mappingHeaders = [
    { key: 'sourceHeaderName', title: 'Excel Column Name'},
    { key: 'revisedHeaderName', title: 'Target Column Name'},
    { key: 'dataType', title: "Data Type"},
    { key: 'dataLength', title: 'Max Data Length'},
    { key: 'validValues', title: 'Restricted Values'}
  ]
  const guidelines = [
      '1.   Only Excel documents can be uploaded.',   
      '2.   Excel document must only contain a single worksheet.',
      '3.   Keep Excel column names consistent. Click the `View Mapping` button for assistance.',
      '4.   Excel column names must not have spaces. e.g. [Incorrect: `AffinityID `] [Correct: `AffinityID`].',
      '5.   Import processes Excel column names with Case Sensitivity. e.g. [AffinityID] and [affinityId] are not equivalent.',
      '6.   Date values must be in the following format, yyyy-mm-dd.',
      '7.   Enure AffinityIDs are numeric.',
      '8.   Enure email addresses are valid.',
      '9.   Ensure currency values are correctly formatted e.g. [Incorrect: $1 000,00] [Correct: 1000.00].'
  ]

  const uploaderRef = ref(null)
  
  const disableButton = computed(() => {
    if (currentStep.value <= 1) {
      if (selectedFile.value === null) {
        return true
      }    
      else {
        return 'prev'
      }
    }
    else if (currentStep.value === totalSteps.value) {
      return 'next'
    }
    else {
      return undefined
    }
  })
  
  const stepStatus = (step) => {
    return currentStep.value > step ? 'green' : 'pink'
  }
  
  const fileToProcess = (file) => {
    selectedFile.value = file
    importResult.value = []
    importSuccess.value = false
  }
  
  const importDocument = () => {
    overlay.value = true
    excelStore.importExcelDocument(selectedFile.value, className.value, quarter.value, week.value).then(result => {
      importResult.value = result.feedback
      importSuccess.value = result.success
  
      overlay.value = false
    }).catch(error => {
      console.log('importExcelDocument', error)
    })
  }
  
  const resetUploader = () => {
    uploaderRef.value.reset()
  }

  const viewMapping = () => {
    mappingData.value = []    
    showMappingHelp.value = true
    showGuideHelp.value = false
    helpTitle.value = 'Column Mappings'
    showHelp.value = true

    excelStore.getImportMappingData(className.value).then(result => {
        if (result.success === true && result.hasData === true){
          mappingData.value = result.mappings
        }
    }).catch(error => {
        console.log('getImportMappingData', error)
    })
  }

  const viewGuide = () => {
    showMappingHelp.value = false
    showGuideHelp.value = true
    helpTitle.value = 'Import Guidelines'
    showHelp.value = true
  }
  
  onMounted(() => {
    weeks.value = [...systemStore.getWeeksInQuarter()]

    systemStore.getQuarters().then(result => {
    if (result.success) {
      // Filter quarters to only those that are relevant for data import
      quarters.value = result.quarters
        .filter(q => q.dataImportQuarters === true)
        .map(q => q.quarter)
      quarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter
      week.value = systemStore.getCurrentWeekInQuarter(weeks.value, quarter.value)
      if (week.value == undefined) {
        week.value = 'Week 1'
      }
    }
    }).catch(error => {
      console.log('recalculateLocalValue', error)
    })
  })
  
  </script>
  
  <style scoped>
  .main {
      display: flex;
      flex-grow: 1;
      align-items: start;
      justify-content: center;
      text-align: center;
      height: auto;
      padding: 10px;
  }
  
  .card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: start;
    text-align: center;
    min-height: 350px;
    padding: 10px;
  }

  .helpToolbar {
    position: absolute;
    right: 0;
  }
  
  </style>